// extracted by mini-css-extract-plugin
export default {"wrapper":"SupportButton_wrapper__psIji","primary":"SupportButton_primary__C68fQ"};